import React from 'react';
import TaxBillIssuedInfo from '../../components/taxbillmng/TaxBillIssuedInfo';

const TaxBillIssuedInfoContainer = ({ taxbill }) => {

  return <TaxBillIssuedInfo taxbill={taxbill} />
};

export default TaxBillIssuedInfoContainer;
